
import { defineComponent, ref, onMounted, onBeforeUnmount } from 'vue';

import TheHeader from '@/components/TheHeader.vue';
import TheError from '@/components/TheError.vue';
import ServersTable from '@/components/ServersTable.vue';
import UpdateTime from '@/components/UpdateTime.vue';
import ServersCard from '@/components/ServersCard.vue';
import TheFooter from '@/components/TheFooter.vue';
import { BoxItem, StatusItem, ServerItem } from '@/types';
import { komariApi } from '@/services/api';

export default defineComponent({
  name: 'App',
  components: {
    TheHeader,
    TheError,
    ServersTable,
    ServersCard,
    TheFooter,
    UpdateTime
  },
  setup() {
    const servers = ref<Array<StatusItem | BoxItem>>();
    const updated = ref<number>();
    let timer: number | undefined;

    // 排序函数，按 weight 从大到小
    function sortByWeight(arr: Array<StatusItem | BoxItem>) {
      return arr?.slice().sort((a, b) => (a.weight) - (b.weight));
    }

    // 初始化 Komari API
    const initializeKomariApi = async () => {
      try {
        komariApi.connectWebSocket(
          (data: ServerItem[]) => {
            // 转换为兼容格式的数据并排序
            servers.value = sortByWeight(komariApi.convertToLegacyFormat(data));
            updated.value = Math.floor(Date.now() / 1000);
          },
          (error) => {
            console.error('Komari API WebSocket 连接失败:', error);
            servers.value = undefined;
          }
        );

        // 初始化获取一次数据
        const fetchAndUpdate = async () => {
          try {
            const serverData = await komariApi.getServers();
            servers.value = sortByWeight(komariApi.convertToLegacyFormat(serverData));
            updated.value = Math.floor(Date.now() / 1000);
          } catch (error) {
            console.error('获取服务器数据失败:', error);
            servers.value = undefined;
          }
        };
        
        await fetchAndUpdate();
        console.log('成功连接到 Komari API');
      } catch (error) {
        console.error('Komari API 初始化失败:', error);
        servers.value = undefined;
      }
    };

    onMounted(async () => {
      await initializeKomariApi();
    });

    onBeforeUnmount(() => {
      if (timer) {
        clearInterval(timer);
      }
      komariApi.disconnectWebSocket();
    });

    return {
      servers,
      updated
    };
  }
});
